import QueryString from 'qs';

import { paths } from '@luxuryescapes/contract-svc-tag';

import { json_headers, request } from './common';

const BASE_URL = `${window.configs.API_HOST}/api/tags/v1`;

export type TagType = 'larger' | 'larger-with-description' | 'medium' | 'small';
export type Tag = paths['/api/tags/v1/tags/{id}']['get']['responses']['200']['content']['application/json']['result'];
export type TagAssignment =
  paths['/api/tags/v1/tag-assignments/{id}']['get']['responses']['200']['content']['application/json']['result'];
export type TagSchedule =
  paths['/api/tags/v1/schedules/{id}']['get']['responses']['200']['content']['application/json']['result'];

export type GetTagResponse = paths['/api/tags/v1/tags/{id}']['get']['responses']['200']['content']['application/json'];
async function getTag(id: string) {
  const { result }: GetTagResponse = await request(`${BASE_URL}/tags/${id}?disableCache=true`, {
    method: 'GET',
  });
  return result;
}

export type GetTagsParams = paths['/api/tags/v1/tags']['get']['parameters']['query'];
export type GetTagsResponse = paths['/api/tags/v1/tags']['get']['responses']['200']['content']['application/json'];
async function getTags(params?: GetTagsParams): Promise<GetTagsResponse> {
  const queryString = params ? QueryString.stringify(params) : '';
  const url = queryString
    ? `${BASE_URL}/tags-internal?${queryString}&showInactive=true&disableCache=true`
    : `${BASE_URL}/tags-internal?showInactive=true&disableCache=true`;
  return request(url, { method: 'GET' });
}

export type CreateTagInput = paths['/api/tags/v1/tags']['post']['requestBody']['content']['application/json'];
export type CreateTagResponse = paths['/api/tags/v1/tags']['post']['responses']['201']['content']['application/json'];
async function createTag(data: CreateTagInput) {
  const { result }: CreateTagResponse = await request(`${BASE_URL}/tags`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(data),
  });
  return result;
}

export type GetTagAssignmentsParams = paths['/api/tags/v1/tag-assignments-internal']['get']['parameters']['query'];
export type GetTagAssignmentsResponse =
  paths['/api/tags/v1/tag-assignments-internal']['get']['responses']['200']['content']['application/json'];
async function getTagAssignments(params?: GetTagAssignmentsParams): Promise<GetTagAssignmentsResponse> {
  const queryString = params ? QueryString.stringify(params) : '';
  const url = queryString
    ? `${BASE_URL}/tag-assignments-internal?${queryString}&disableCache=true`
    : `${BASE_URL}/tag-assignments-internal?disableCache=true`;
  return request(url, { method: 'GET' });
}

export type CreateTagAssignmentInput =
  paths['/api/tags/v1/tag-assignments-bulk']['post']['requestBody']['content']['application/json'];
export type CreateTagAssignmentResponse =
  paths['/api/tags/v1/tag-assignments-bulk']['post']['responses']['201']['content']['application/json'];
async function createTagAssignment(data: CreateTagAssignmentInput) {
  const { result }: CreateTagAssignmentResponse = await request(`${BASE_URL}/tag-assignments-bulk`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(data),
  });
  return result;
}

async function deleteTagAssignment(id: string): Promise<void> {
  return request(`${BASE_URL}/tag-assignments/${id}`, {
    method: 'DELETE',
  });
}

async function deleteTagAssignmentBulk(ids: Array<string>): Promise<void> {
  return request(`${BASE_URL}/tag-assignments-bulk`, {
    method: 'DELETE',
    headers: json_headers,
    body: JSON.stringify({ ids }),
  });
}

export type GetTagSchedulesParams = paths['/api/tags/v1/schedules']['get']['parameters']['query'];
export type GetTagSchedulesResponse =
  paths['/api/tags/v1/schedules']['get']['responses']['200']['content']['application/json'];
async function getTagSchedules(params?: GetTagSchedulesParams): Promise<GetTagSchedulesResponse> {
  const queryString = params ? QueryString.stringify(params) : '';
  const url = queryString
    ? `${BASE_URL}/schedules?${queryString}&disableCache=true`
    : `${BASE_URL}/schedules?disableCache=true`;
  return request(url, { method: 'GET' });
}

export type CreateTagScheduleInput =
  paths['/api/tags/v1/schedules']['post']['requestBody']['content']['application/json'];
export type CreateTagScheduleResponse =
  paths['/api/tags/v1/schedules']['post']['responses']['201']['content']['application/json'];
async function createTagSchedule(data: CreateTagScheduleInput) {
  const { result }: CreateTagScheduleResponse = await request(`${BASE_URL}/schedules`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify(data),
  });
  return result;
}

export type UpdateTagScheduleInput =
  paths['/api/tags/v1/schedules/{id}']['patch']['requestBody']['content']['application/json'];
export type UpdateTagScheduleResponse =
  paths['/api/tags/v1/schedules/{id}']['patch']['responses']['200']['content']['application/json'];
async function updateTagSchedule(id: string, data: UpdateTagScheduleInput) {
  const { result }: UpdateTagScheduleResponse = await request(`${BASE_URL}/schedules/${id}`, {
    method: 'PATCH',
    headers: json_headers,
    body: JSON.stringify(data),
  });
  return result;
}

export default {
  getTag,
  getTags,
  createTag,
  getTagAssignments,
  createTagAssignment,
  deleteTagAssignment,
  deleteTagAssignmentBulk,
  getTagSchedules,
  createTagSchedule,
  updateTagSchedule,
};
